import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import MainCharacteristics from "@/bit/components/components.characteristics";
import BuyBox from "@/bit/components/components.buy-box";
// import BuyBox from "@/component/buy-box";
import getDeviceKindDependsOnViewPort from "@gcloud-npm/utils.common.get-device-kind-depends-on-viewport";
import Card from "@/component/card";
import Text from "@/bit/components/components.text";
import PageSelector from "@/bit/components/components.page-selector";
// import PageSelector from "@/component/page-selector";
import { actions as modalActions } from "@/bit/reducers/reducers.modals-reducer";
const ImageSlider = dynamic(() =>
  import("@/bit/components/components.image-slider")
);
const FormSolar360 = dynamic(() => import("@/component/formSolar360"));

const ProductBanner = (props) => {
  const {
    productName,
    orionTitle,
    orionBanner,
    orionBuyBox,
    orionCharacs,
    orionSelector,
    orionImageSlider,
    simphePhoneFicha,
    alias,
  } = props;

  const dispatch = useDispatch();

  const handleModalSolar360 = () => {
    const device = getDeviceKindDependsOnViewPort();
    const MODAL_PROPS = {
      contentPosition:
        device !== "MOBILE" ? "center--center" : "center--bottom",
      opacityLayoutColor: "black05",
      inSceneEffect: "fadeInBottom",
      outSceneEffect: "fadeOutBottom",
      closeByClickingOutside: true,
      scrollAllowed: false,
    };
    dispatch(
      modalActions.addModal({
        id: "contratacionSolar360",
        type: "MODAL",
        elementProps: {},
        Element2Show: FormSolar360,
        modalProps: MODAL_PROPS,
      })
    );
  };

  return (
    <>
      <div
        className="product-banner container"
        data-cy="Section Product Banner"
      >
        <div
          className={`product-banner-left`}
          data-cy="Product Banner Left"
        >
          <div className="banner-cards">
            {orionTitle && (
              <Text {...orionTitle["Text-1"]} kind="h" level="1" />
            )}
            {orionImageSlider ? (
              <ImageSlider
                name={orionImageSlider["Title-1"]}
                images={orionImageSlider["Images-1"]}
              />
            ) : (
              <Card
                {...orionBanner}
                setPriority={true}
                cardShadow={
                  !(
                    productName === "configura-tv-r" ||
                    productName === "movistarplus"
                  )
                }
              ></Card>
            )}
          </div>
        </div>
        <div className="banner-right" data-cy="Product Banner Right">
          {orionSelector && Object.keys(orionSelector).length !== 0 && (
            <PageSelector {...orionSelector} />
          )}
          <BuyBox
            {...orionBuyBox}
            simplePhone={simphePhoneFicha}
            productName={productName}
            alias={alias}
            Product-1={{
              ...orionBuyBox["Product-1"],
              "Button-1": {
                ...orionBuyBox["Product-1"]["Button-1"],
                onClick:
                  orionBuyBox["Product-1"]["Button-1"].onclickBinding &&
                  (productName === "energia" || productName === "energia-inteligente" || productName === "energia-convencional")
                    ? handleModalSolar360
                    : null,
              },
            }}
          ></BuyBox>
          <br />
          <MainCharacteristics {...orionCharacs} />
          {orionBuyBox["Product-1"]["Channels-1"] && (
            <ChannelLink {...orionBuyBox["Product-1"]["Channels-1"]} />
          )}
        </div>
      </div>

      <style jsx>{`
        .product-banner {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          min-height: 513px;
          padding-top: 2rem;

          .banner-gap {
            display: none;
          }
          .banner-right {
            width: 100%;
          }
          .product-banner-left {
            display: block;
            width: 100%;
            height: 100%;
            aspect-ratio: 4 / 3;
            flex: 1;

            .banner-cards {
              height: 100%;
              display: flex;
              flex-direction: column;
              :global(.card-column) {
                z-index: -1;
              }
            }
          }
        }
        @media screen and (min-width: 768px) {
          .product-banner {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 2rem;

            .product-banner-left {
              display: block;

              .banner-cards {
                height: 100%;
                :global(.card-container) {
                  justify-content: flex-end;
                  :global(.card-glyph) {
                    width: 50%;
                    margin: 0 auto;
                  }
                  :global(.card-text-list) {
                    :global(.text-list) {
                      text-align: center;
                      margin: 0.5rem 2rem;
                    }
                  }
                }
              }
            }

            .banner-gap {
              display: block;
              width: 4rem;
            }
            .banner-right {
              width: 48%;
            }
          }
        }
        @media screen and (min-width: 1024px) {
          .product-banner {
            gap: 4rem;

            .banner-gap {
              width: 8rem;
            }
          }
        }
      `}</style>
    </>
  );
};

ProductBanner.propTypes = {
  layout: PropTypes.string,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
};

ProductBanner.defaultProps = {
  layout: "",
  backgroundColor: "white",
  className: "",
};

export default ProductBanner;
